module.exports = __webpack_public_path__ + "img/logo-aiDubbing-light-mode.962c0533.svg";